export default __webpack_public_path__ + "static/commerce-platform-cover-93f44d75583ea3b70e19fda1d48b9773.png";